import React from 'react';
import { ButtonLoader, ButtonLoaderVariants } from '../../../ButtonLoader/ButtonLoader';

export interface OutlineOnHoverRoundedDangerLargeProps {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    isLoading?: boolean;
    children?: React.ReactNode;
}

export const OutlineOnHoverRoundedDangerLarge: React.FC<OutlineOnHoverRoundedDangerLargeProps> = ({ onClick, disabled, isLoading, children }) => {
    return (
        <button
            className='disabled:cursor-not-allowed flex'
            onClick={onClick}
            disabled={disabled || isLoading}
        >
            {isLoading ? <ButtonLoader variant={ButtonLoaderVariants.SMALL} /> : null}
            {children}
        </button>
    );
};
